/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * reserve_trip_map の取得条件
 * @export
 * @interface ReserveTripMapRequest
 */
export interface ReserveTripMapRequest {
    /**
     * ログイン(開局) 単位で発行されるID
     * @type {string}
     * @memberof ReserveTripMapRequest
     */
    loginSessionId: string;
    /**
     * 空車での trip_session_id
     * @type {string}
     * @memberof ReserveTripMapRequest
     */
    unladenTripSessionId: string;
    /**
     * 空車開始時刻(UTC, フォーマット '2023-05-02T04:13:18Z')
     * @type {string}
     * @memberof ReserveTripMapRequest
     */
    unladenStartTs: string;
}

export function ReserveTripMapRequestFromJSON(json: any): ReserveTripMapRequest {
    return ReserveTripMapRequestFromJSONTyped(json, false);
}

export function ReserveTripMapRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReserveTripMapRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'loginSessionId': json['login_session_id'],
        'unladenTripSessionId': json['unladen_trip_session_id'],
        'unladenStartTs': json['unladen_start_ts'],
    };
}

export function ReserveTripMapRequestToJSON(value?: ReserveTripMapRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'login_session_id': value.loginSessionId,
        'unladen_trip_session_id': value.unladenTripSessionId,
        'unladen_start_ts': value.unladenStartTs,
    };
}


